<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="6">
            <div>
              <el-input placeholder="请输入搜索关键字" v-model="key" size="medium" style="width: 97%;" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="7">
            <div>
              <el-button size="medium" type="primary" @click="getActivitys()" icon="el-icon-search">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              &nbsp;
            </div>
          </el-col>
          <el-col :span="2">
            <el-button @click="openDialog('add', null)" type="success" size="medium"
              v-if="checkButtonPermission('front:manage:activity:hot:add')">新增活动</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" min-height="400">
          <el-table-column prop="sort" label="排序" min-width="40" />
          <el-table-column prop="image" label="列表海报图" width="180">
            <template slot-scope="scope">
              <img :src="scope.row.image" width="32" height="32" />
            </template>
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称" width="180"></el-table-column>
          <el-table-column prop="channelId" label="渠道" min-width="90">
            <template slot-scope="scope" v-if="scope.row.channelList">
              <span v-for="posterChannel in scope.row.channelList" v-html="posterChannel.channelName + '、'" />
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="发布时间" width="180"></el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">未开始</span>
              <span v-else-if="scope.row.status == 1">进行中</span>
              <span v-else-if="scope.row.status == 2">已结束</span>
              <span v-else-if="scope.row.status == 3">已禁用</span>
            </template>
          </el-table-column>
          <el-table-column prop="activityCategory" label="类型" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.activityCategory == 1">海报</span>
              <span v-else-if="scope.row.activityCategory == 0">文章</span>
              <span v-else-if="scope.row.activityCategory == 2">导购</span>
              <span v-else-if="scope.row.activityCategory == 3">车贷</span>
              <span v-else-if="scope.row.activityCategory == 4">公众号文章</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == 3 && checkButtonPermission('front:manage:activity:hot:enable')"
                @click="activityOperation(scope.row.activityId, 1)" type="success" size="mini">启用
              </el-button>
              <el-button v-else-if="scope.row.status == 1 && checkButtonPermission('front:manage:activity:hot:enable')"
                @click="activityOperation(scope.row.activityId, 3)" type="danger" size="mini">禁用
              </el-button>
              <el-button
                v-if="(scope.row.status == 1 || scope.row.status == 3) && checkButtonPermission('front:manage:activity:hot:end')"
                @click="activityOperation(scope.row.activityId, 2)" type="danger" size="mini">结束活动
              </el-button>
              <el-button
                v-else-if="(scope.row.status == 0 || scope.row.status == 2) && checkButtonPermission('front:manage:activity:hot:end')"
                @click="activityOperation(scope.row.activityId, 1)" type="success" size="mini">开启活动
              </el-button>
              <el-button size="mini" @click="openDialog('edit', scope.row)"
                v-if="checkButtonPermission('front:manage:activity:hot:edit')">&nbsp;&nbsp;&nbsp;编&nbsp;&nbsp;辑&nbsp;&nbsp;&nbsp;</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :modal="false" :close-on-click-modal="false"
      @close="resetForm('activityForm')">

      <el-form :model="activityForm" ref="activityForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="排序" prop="sort">
          <el-input-number clearable v-model="activityForm.sort" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="渠道" prop="channelId">
          <el-select v-model="selectedChannels" multiple placeholder="请选择渠道">
            <el-option v-for="channel in channels" :key="channel.channelId" :label="channel.channelName"
              :value="channel.channelId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称" prop="activityName">
          <el-input v-model="activityForm.activityName"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="statusSelect" @change="statusSelectChange">
            <el-option v-for="option in statusOptions" :label="option.label" :value="option.value"
              :key="option.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="活动类型" prop="status">
          <el-select v-model="categorySelectVal" @change="categorySelectChange">
            <el-option v-for="option in categoryOptions" :label="option.label" :value="option.value"
              :key="option.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="categorySelectVal == 1" label="请选择海报" prop="status">
          <el-select v-model="posterSelect" @change="posterSelectChange">
            <el-option v-for="option in posterOptions" :label="option.title" :value="option.posterId"
              :key="option.posterId" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="categorySelectVal == 0" label="请选择文章" prop="status">
          <el-select v-model="articleSelect" @change="articleSelectChange">
            <el-option v-for="option in articleOptions" :label="option.title" :value="option.articleId"
              :key="option.articleId" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="categorySelectVal == 4" label="公众号文章" prop="status">
          <el-input v-model="wechatUrlSelect"></el-input>
        </el-form-item>
        <el-form-item label="活动图片" prop="image">
          <el-upload ref="upload" :file-list="fileList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadActivityImageSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频">
          <div class="image-wrap" v-if="video">
            <video style="width: 300px;" name="upfile" :src="video" class="avatar"
              controls="controls">您的浏览器不支持视频播放</video>
            <div
              style="color: red; border: 1px solid red; border-radius: 5px; text-align: center; width: 200px; cursor: pointer;"
              @click="() => {
                this.video = '';
              }">删除视频</div>
          </div>
          <el-upload v-else v-loading="videoLoading" ref="upload2" :file-list="fileList2"
            :action="this.env.env.uploadUrl" :list-type="video ? '' : 'picture-card'" :limit="1"
            :on-progress="uploadVideoProcess" :on-success="uploadAdvertiseVideoSuccess">
            <i class="el-icon-plus" v-loading="videoLoading"><span v-if="videoLoading">上传中</span></i>
          </el-upload>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitActivity('activityForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "activityList",
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      key: '',
      activityForm: { sort: 1 },
      dialogVisible: false,
      dialogAction: '',
      fileList: [],
      uploadImage: '',
      dialogTitle: "新增",
      statusOptions: [
        {
          label: '未开始',
          value: 0
        },
        {
          label: '进行中',
          value: 1
        },
        {
          label: '已结束',
          value: 2
        },
        {
          label: '已禁用',
          value: 3
        },
      ],
      statusSelect: '',
      statusSelectVal: -1,
      categoryOptions: [
        {
          label: '文章',
          value: 0
        },
        {
          label: '海报',
          value: 1
        },
        {
          label: '导购',
          value: 2
        },
        {
          label: '车贷',
          value: 3
        },
        {
          label: '公众号文章',
          value: 4
        }
      ],
      categorySelect: '海报',
      categorySelectVal: 1,
      posterSelect: '',
      posterSelectVal: -1,
      posterOptions: [],
      articleSelect: '',
      articleSelectVal: -1,
      articleOptions: [],
      activityId: '',
      extenId: '',
      wechatUrlSelect: '',
      selectedChannels: [],
      channels: [],
      fileList2: [],
      video: '',
      videoLoading: '',
    }
  },
  created() {
    this.getActivitys();
  },
  methods: {
    getActivitys() {
      let reqParam = {
        key: this.key,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$http.post('/api/front/activity/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if ("success" == data.code) {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    addActivity(formName, reqParam) {
      this.$http.post('/api/front/activity/add', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if ("success" === data.code) {
          this.getActivitys();
          this.$message({
            message: '新增活动成功',
            type: 'success'
          });
          // 3.关闭模态框
          this.dialogVisible = false;
          this.resetForm(formName);
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },

    updateActivity(formName, reqParam) {
      this.$http.post('/api/front/activity/update', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if ("success" === data.code) {
          this.getActivitys();
          this.$message({
            message: '编辑活动成功',
            type: 'success'
          });
          // 3.关闭模态框
          this.dialogVisible = false;
          this.resetForm(formName);
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    submitActivity(formName) {
      if (this.categorySelectVal == 4) {
        this.extenId = this.wechatUrlSelect;
      }
      if (dialogAction.ADD == this.dialogAction) {
        let reqParam = {
          // 活动名称
          activityName: this.activityForm.activityName,
          // 状态
          status: this.statusSelectVal,
          // 活动类型
          activityCategory: this.categorySelectVal,
          // 海报
          image: this.uploadImage,
          extenId: this.extenId,
          sort: this.activityForm.sort,
          channels: this.selectedChannels,
          video: this.video
        };
        this.addActivity(formName, reqParam);
      } else if (dialogAction.EDIT == this.dialogAction) {
        let reqParam = {
          activityId: this.activityId,
          // 活动名称
          activityName: this.activityForm.activityName,
          // 状态
          status: this.statusSelectVal,
          // 活动类型
          activityCategory: this.categorySelectVal,
          // 海报
          image: this.uploadImage,
          extenId: this.extenId,
          sort: this.activityForm.sort,
          channels: this.selectedChannels,
          video: this.video
        };
        console.log(reqParam)
        this.updateActivity(formName, reqParam);

      }
    },
    activityOperation(activityId, status) {
      let reqParam = {
        activityId: activityId,
        status: status,
      };
      this.$http.post('/api/front/activity/update', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.getActivitys();
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },

    getPosters(action) {
      let reqParam = {
        size: 10000
      };
      this.$http.post('/api/popularize/poster/search', reqParam).then(resp => {
        console.log(resp);
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          let posterOptions = pageInfo.list;
          if (dialogAction.ADD == action) {
            var newArr = new Array();
            for (var i = 0; i < posterOptions.length; i++) {
              var j = posterOptions[i];
              if (j.status === 1) {
                newArr.push(j);
              }
            }
            this.posterOptions = newArr;
          } else if (dialogAction.EDIT == action) {
            this.posterOptions = posterOptions
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },

    getArticles(action) {
      let reqParam = {
      };
      this.$http.post('/api/popularize/article/search', reqParam).then(resp => {

        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          let articleOptions = pageInfo.list;
          if (dialogAction.ADD == action) {
            var newArr = new Array();
            for (var i = 0; i < articleOptions.length; i++) {
              var j = articleOptions[i];
              if (j.status === 1) {
                newArr.push(j);
              }
            }
            this.articleOptions = newArr;
          } else if (dialogAction.EDIT == action) {
            this.articleOptions = articleOptions
          }
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getChannels() {
      this.$http.post('/api/channel-service/channel/logged/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp.data.resultList)
        let data = resp.data;
        this.channels = data.resultList;
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      });
    },
    articleSelectChange(val) {
      this.articleSelectVal = val;
      this.extenId = val
    },
    posterSelectChange(val) {
      this.posterSelectVal = val;
      this.extenId = val
    },
    statusSelectChange(val) {
      this.statusSelectVal = val;
    },
    categorySelectChange(val) {
      this.categorySelectVal = val;
      if (val === 1) {
        this.posterSelect = '',
          this.posterSelectVal = -1,
          this.getPosters(this.dialogAction)
      } else {
        this.articleSelect = '',
          this.articleSelectVal = -1,
          this.getArticles(this.dialogAction)
      }
    },
    uploadActivityImageSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.uploadImage = resp.data
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    handlePictureCardPreview(file) {
    },
    handleRemove(file, fileList) { },
    uploadVideoProcess(event, file, fileList) {
      this.videoLoading = event.percent;
    },
    uploadAdvertiseVideoSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.video = resp.data;
        this.videoLoading = '';
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    openDialog(action, data) {
      this.video = '';
      if (dialogAction.ADD == action) {
        this.dialogTitle = "新增"
        this.getChannels();
        this.getPosters(dialogAction.ADD);
      } else if (dialogAction.EDIT == action) {
        this.dialogTitle = "编辑"
        this.getChannels();
        if (data.activityCategory == 1) {
          this.getPosters(dialogAction.EDIT);
        } else {
          this.getArticles(dialogAction.EDIT);
        }
        this.activityId = data.activityId
        this.activityForm = JSON.parse(JSON.stringify(data));
        this.fileList.push({
          "url": data.image,
          "name": '',
          "id": ''
        })
        this.video = data.video || '';
        for (var o in data.channelList) {
          this.selectedChannels.push(data.channelList[o].channelId)
        }
        this.categorySelectVal = data.activityCategory
        this.statusSelect = data.status
        this.statusSelectVal = data.status
        this.posterSelect = data.extenId
        this.posterSelectVal = data.extenId
        this.articleSelect = data.extenId
        this.articleSelectVal = data.extenId
        this.wechatUrlSelect = data.extenId

        this.uploadImage = data.image
      }
      this.dialogVisible = true;
      this.dialogAction = action;
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.getActivitys();
    },
    pageSizeChange(val) {
      this.pageSize = val;
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    resetForm(formName) {
      this.statusSelectVal = -1;
      this.statusSelect = '';
      this.activityForm = {};
      this.posterSelect = '';
      this.posterSelectVal = -1;
      this.articleSelect = '';
      this.articleSelectVal = -1;
      this.selectedChannels = [];
      this.$refs[formName].resetFields();
      this.activityForm = { sort: 1 };
      this.fileList = [];
      this.fileList2 = [];
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/activityList.vue